import { Contact } from './contact';
import { ServiceLevel } from './service-level';
import { SubscriptionInfo } from './thing';

export class Customer {
    id: string;
    name: string;
    country: string;
    timezone: string;
    properties: { [propertyName: string]: string | number | Contact[] };
    values: any;
    type: string;
    code: string;
    pendingVerification?: boolean;
    firstAccessTimestamp?: number;
    lastAccessTimestamp?: number;
    serviceLevel?: ServiceLevel
    privateMetricIds?: string[];
    publicMetricsUntilTimestamp?: number;
    partner?: RelatedPartner;
    subscriptionInfo?: SubscriptionInfo;
    externalId: string;
    lastUpdateTimestamp: number;
    lastSyncTimestamp: number;
    creationTimestamp: number;
}

export class RelatedPartner {
    id: string;
    name: string;
    code: string;
    country: string;
    timezone: string;
    properties: { [propertyName: string]: string | number | Contact[] };
}
